/* global navigator */

/**
 * Geolocation Service
 * @type {{getLocation: serviceGeolocation.getLocation, geoLocateUser: serviceGeolocation.geoLocateUser}}
 */
var serviceGeolocation = {

  /**
   * Get User location
   * @returns {*|Promise.<TResult>}
   */
  getLocation: function() {
    return this.geoLocateUser().then(function(position) {
      return {lat: position.coords.latitude, lng: position.coords.longitude};
    });
  },

  /**
   * Geolocate User
   * @returns {Promise}
   */
  geoLocateUser: function() {
    return new Promise(function(resolve, reject) {
      if ('geolocation' in navigator) {
        navigator.geolocation.getCurrentPosition(function(position) {
          if (position) {
            resolve(position);
          }
        }, function(error) {
            reject(error);
        });
      } else {
        reject(new Error('Geolocation Failed'));
      }
    });
  }
};
